import { useQuery } from "@tanstack/react-query";
import { GetEligibleSendersResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { useAuthentication } from "../auth/useAuthentication.ts";
import { queryKeys } from "./queryKeys.ts";

export const useEligibleSenderIds = () => {
  const { getToken, isAuthenticated } = useAuthentication();

  return useQuery({
    queryKey: queryKeys.eligibleSenders(),
    queryFn: async ({
      signal,
    }): Promise<GetEligibleSendersResponse["senderIds"]> => {
      const token = await getToken();
      const response = await fetch(`/api/cards/eligibleSenders`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal,
      });

      if (!response.ok) {
        throw new Error("Server returned status outside the 200 range.");
      }

      const eligibleSendersResponse =
        (await response.json()) as GetEligibleSendersResponse;
      return eligibleSendersResponse.senderIds;
    },
    enabled: isAuthenticated,
    placeholderData: [],
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
